import { Component, OnInit } from "@angular/core";
import { FormGroup, NgForm } from "@angular/forms";
import { MessageService } from "primeng/api";
import { MailregisterService } from "src/app/argic/services/mailregister.service";
import { RegisterForm } from "./register-form";

@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"],
    providers:[MessageService]
})
export class RegisterComponent implements OnInit {
    selectedCurrency: any = null;

    currencies: any[] = [
        { name: "CHF", code: "CHF" },
        { name: "EUR", code: "EUR" },
        { name: "GBP", code: "GBP" },
        { name: "JPY", code: "JPY" },
        { name: "USD", code: "USD" },
    ];

    selectedLanguage: any = null;

    languages: any[] = [
        { name: "English", code: "English" },
        { name: "Español", code: "Español" },
        { name: "Français", code: "Français" },
        { name: "Italiano", code: "Italiano" },
        { name: "Nederlands", code: "Nederlands" },
        { name: "Português", code: "Português" },
        { name: "Türkçe", code: "Türkçe" },
        { name: "Русский", code: "Русский" },
    ];

    selectedDF: any = null;

    df: any[] = [
        { name: "DD/MM/YYYY", code: "DD/MM/YYYY" },
        { name: "MM/DD/YYYY", code: "MM/DD/YYYY" },
        { name: "YYYY/MM/DD", code: "YYYY/MM/DD" },
    ];

    selectedProfile: any = null;

    profiles: any[] = [
        { name: "Automotive Glass Fitter", code: "Automotive Glass Fitter" },
        {
            name: "Automotive Glass Producer",
            code: "Automotive Glass Producer",
        },
        {
            name: "Automotive Glass Wholesaler",
            code: "Automotive Glass Wholesaler",
        },
        { name: "Bodyshop Repair", code: "Bodyshop Repair" },
        {
            name: "Mouldings and Rubbers Producer",
            code: "Mouldings and Rubbers Producer",
        },
        {
            name: "Mouldings and Rubbers Wholesaler",
            code: "Mouldings and Rubbers Wholesaler",
        },
        {
            name: "OE-car dealer/Garage owner",
            code: "OE-car dealer/Garage owner",
        },
    ];

    selectedCountry: any = null;
    countries: any[] = [
        { name: "Albania", code: "Albania" },
        { name: "Austria", code: "Austria" },
        { name: "Belgium", code: "Belgium" },
        { name: "Bosnia and Herzegovina", code: "Bosnia and Herzegovina" },
        { name: "Bulgaria", code: "Bulgaria" },
        { name: "Croatia", code: "Croatia" },
        { name: "Cyprus", code: "Cyprus" },
        { name: "Czech Republic", code: "Czech Republic" },
        { name: "Denmark", code: "Denmark" },
        { name: "Estonia", code: "Estonia" },
        { name: "Finland", code: "Finland" },
        { name: "France", code: "France" },
        { name: "Germany", code: "Germany" },
        { name: "Greece", code: "Greece" },
        { name: "Hungary", code: "Hungary" },
        { name: "Ireland", code: "Ireland" },
        { name: "Italy", code: "Italy" },
        { name: "Latvia", code: "Latvia" },
        { name: "Lithuania", code: "Lithuania" },
        { name: "Luxembourg", code: "Luxembourg" },
        { name: "Malta", code: "Malta" },
        { name: "Netherlands", code: "Netherlands" },
        { name: "Poland", code: "Poland" },
        { name: "Portugal", code: "Portugal" },
        { name: "Romania", code: "Romania" },
        { name: "Slovakia", code: "Slovakia" },
        { name: "Slovenia", code: "Slovenia" },
        { name: "Spain", code: "Spain" },
        { name: "Sweden", code: "Sweden" },
        { name: "Turkey", code: "Turkey" },
        { name: "United Kingdom", code: "United Kingdom" },
    ];

    registerForm = new RegisterForm();
    constructor(
        private messageService: MessageService,
        private mailRegisterService: MailregisterService
    ) {}

    ngOnInit(): void {}

    register(form: NgForm) {
        Object.keys(form.controls).forEach((element) => {
            form.controls[element].markAsDirty();
            form.controls[element].updateValueAndValidity();
        });
        if (form.invalid) {
            this.messageService.add({
                key: "tc",
                severity: "error",
                summary: "Error",
                detail: "Please correct the form",
            });
        } else {

            this.registerForm.profile = this.selectedProfile['code'];
            this.registerForm.country = this.selectedCountry['code'];
            // this.registerForm.currency = this.selectedCurrency['code'];
            // this.registerForm.language = this.selectedLanguage['code'];
            // this.registerForm.dateformat = this.selectedDF['code'];

            this.mailRegisterService
                .registerMail(this.registerForm)
                .subscribe((data) => {
                    this.messageService.add({
                        key: "tc",
                        severity: "success",
                        summary: "Success",
                        detail: "Thank you for registering. You will be contacted by our services.",
                    });
                    this.clear(form);
                });
        }
    }

    clear(form: NgForm) {
        Object.keys(form.controls).forEach((element) => {
            form.controls[element].markAsPristine();
        });
        this.registerForm = new RegisterForm();
        this.selectedCountry = null;
        this.selectedCurrency = null;
        this.selectedDF = null;
        this.selectedLanguage = null;
        this.selectedProfile = null;
    }

    onConfirm() {
        this.messageService.clear('c');
    }

    onReject() {
        this.messageService.clear('c');
    }

}
